import { render } from "./WireFrame.vue?vue&type=template&id=fe01a7d8"
import script from "./WireFrame.vue?vue&type=script&lang=js"
export * from "./WireFrame.vue?vue&type=script&lang=js"

import "./WireFrame.vue?vue&type=style&index=0&id=fe01a7d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__